export { default, getStaticPaths, getStaticProps } from '~/pages/course/[slug]';
